import { graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'

import Agenda from '@/components/blocks-library/agenda/agenda'
import { generateSlug } from '@/utils/url'

import * as styles from './agenda-block.module.scss'

interface OpenItem {
  tab: number
  item: number
}

const AgendaBlock: React.FC<Queries.AgendaBlockFragment> = ({
  title,
  agenda
}) => {
  const [tabOpen, setTabOpen] = useState(0)
  const [openItems, setOpenItems] = useState<OpenItem[]>(() => {
    if (typeof window !== 'undefined') {
      const path = generateSlug(window.location.pathname)
      const storedOpenItems = sessionStorage.getItem(`openItems-${path}`)
      if (storedOpenItems) {
        try {
          return JSON.parse(storedOpenItems) as OpenItem[]
        } catch (error) {
          console.error('Failed to parse openItems from sessionStorage:', error)
        }
      }
    }
    return [{ tab: 0, item: 0 }]
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const path = generateSlug(window.location.pathname)
      sessionStorage.setItem(`openItems-${path}`, JSON.stringify(openItems))
    }
  }, [openItems])

  const handleTabs = (index: number) => {
    setTabOpen(index)
    setOpenItems((prevOpenItems) => [...prevOpenItems, { tab: index, item: 0 }])
  }

  const handleItemsAcordion = (itemId: number) => {
    const itemExists = openItems.some(
      (item) => item.item === itemId && item.tab === tabOpen
    )

    if (itemExists) {
      setOpenItems((prevOpenItems) =>
        prevOpenItems.filter((item) => item.item !== itemId)
      )
    } else {
      setOpenItems((prevOpenItems) => [
        ...prevOpenItems,
        { tab: tabOpen, item: itemId }
      ])
    }
  }
  return (
    <div className={styles.agendaSection}>
      <div className="container">
        <h2>
          <span>Agenda / </span>
          {title}
        </h2>
      </div>

      <div className={styles.tabs}>
        <div className="container">
          <div className={styles.items}>
            {agenda?.map((item, index) => {
              if (item === undefined || item === null) return
              return (
                <div
                  onClick={() => handleTabs(index)}
                  className={index == tabOpen ? styles.tabOpen : ''}
                >
                  {item.title}
                </div>
              )
            })}
          </div>
        </div>
      </div>
      {agenda?.map((item, index) => {
        if (item === undefined || item === null) return
        if (index === tabOpen) {
          return (
            <Agenda
              key={item.id}
              {...item}
              openItems={openItems}
              handleItemsAcordion={handleItemsAcordion}
              id={index}
            />
          )
        } else {
          return
        }
      })}
    </div>
  )
}

export default AgendaBlock

export const query = graphql`
  fragment AgendaBlock on DatoCmsAgendaBlock {
    __typename
    id
    title
    navigationLabel
    agenda {
      ... on DatoCmsAgenda {
        ...Agenda
      }
    }
  }
`
